"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ImportSalesOrderLine = void 0;
const common_1 = require("../../common");
const enums_1 = require("../enums");
const sales_order_header_model_1 = require("./sales-order-header.model");
class ImportSalesOrderLine extends common_1.MongoDocument {
}
exports.ImportSalesOrderLine = ImportSalesOrderLine;
//# sourceMappingURL=import-sales-order-line.model.js.map